import React from 'react';

const Footer = () => <div className="footer" />;

export default Footer;
